import { Component } from '@angular/core';
import { NotificationsWidget } from './components/notificationswidget';
import { StatsWidget } from './components/statswidget';
import { RecentSalesWidget } from './components/recentsaleswidget';
import { BestSellingWidget } from './components/bestsellingwidget';
import { RevenueStreamWidget } from './components/revenuestreamwidget';
import { InfoCardComponent } from "./components/info-card/info-card.component";
import { HoroscopeCardComponent } from "./components/horoscope-card/horoscope-card.component";
import { ProductSummaryCardComponent } from "./components/product-summary-card/product-summary-card.component";

@Component({
    selector: 'app-dashboard',
    standalone: true,
    imports: [InfoCardComponent, HoroscopeCardComponent],
    template: `
        <div class="grid grid-cols-12 gap-8">
            <div class="col-span-12 xl:col-span-8">
                <app-info-card />
            </div>
            <div class="col-span-12 xl:col-span-4">
                <app-horoscope-card />
            </div>
        </div>
    `
})
export class Dashboard {}
